/**
 * @module components\ClientForm
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';
import {
  required,
  maxLength,
  minLength,
  requiredIf
} from 'vuelidate/lib/validators';
import { customPattern } from '@/validations/customPattern';
import core from '@/services/core';
import LoaderMobile from '@/services/loaderMobile';
import moment from 'moment';
import constants from '@/constants/constants';
import { Watch } from 'vue-property-decorator';
import sDialog from "@/services/sDialog";
import forgotPassword from '../forgotPassword/forgotPassword';
var shajs = require("sha.js");

@Component({
  validations: function (this: Login) {
    let validation: any = {
      loginCredentials: {
        loginId: {
          required: requiredIf(() => { return (this.loginCredentials.userType == 'ADMIN') }),
          maxLength: maxLength(20)
        },
        mob: {
          required: requiredIf(() => { return (this.loginCredentials.userType == 'USER') }),
          maxLength: maxLength(10),
          minLength: minLength(10)
        },
        password: {
          required
        },
        userType: {
          required
        }
      }
    };
    return validation;
  }
})
export default class Login extends Vue {
  valid = "";
  isAdmin: boolean = true;
  passShow = false;
  loading = false;
  loginCredentials = {
    loginId: "",
    password: "",
    userType: "",
    mob: ""
  };
  userTypes = ["ADMIN", "USER"];
  initLoginResponse = { authId: "", hashCount: "", randomSeed: "" };
  login() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return false;
    }
    this.loading = true;
    let id = this.loginCredentials.userType == 'ADMIN' ? this.loginCredentials.loginId : this.loginCredentials.mob;
    let request = { loginId: id, reqType: "WEB", userType: this.loginCredentials.userType };
    core
      .post({
        data: request,
        url: 'initLogin',
        method: 'post'
      })
      .then(response => {
        this.initLoginResponse = response;
        this.validatePassword();
      })
      .catch(error => {
        this.loading = false;
      });
  }
  sessionValidateResponse = {
    sessionId: "",
    requestModule: "",
    clientId: "",
    requestType: ""
  };
  validatePassword() {
    let request = {
      authId: this.initLoginResponse.authId,
      mode: "WEB",
      masterHashPwd: this.createMasterHash()
    };
    core
      .post({
        data: request,
        url: 'validatePassword',
        method: 'post'
      })
      .then(response => {
        this.sessionValidateResponse = response;
        store.dispatch(
          'updateSessLoginDataAc',
          this.sessionValidateResponse
        );
        this.staticData();

      })
      .catch(error => {
        this.loading = false;
      });
  }
  get staticDataStore() {
    return store.getters.staticDataGet;
  }

  superInit() {
    let totalModule = this.staticDataStore.payload.ccSearchModule.concat(this.staticDataStore.payload.cdSearchModule);
    let moduleSelected = {};
    let client = [];
    if (totalModule.length == 1) {
      moduleSelected = { name: totalModule[0]['displayName'], value: totalModule[0]['value'] };

      client = totalModule.filter(el => {
        return el.value == moduleSelected['value']
      })
    }
    let request = {
      requestModule: store.getters.sessLoginDataGet.requestModule ? store.getters.sessLoginDataGet.requestModule : "CMS",
      token: store.getters.sessLoginDataGet.sessionId,
      requestType: "WEB",
      merchantClientId: store.getters.sessLoginDataGet.clientId,
      requestFor: totalModule.length > 1 ? 'INFO' : 'DASH',
      aggId: client && client.length > 0 ? client[0]['agg_id'] : '',
      finoClientId: moduleSelected['value'] ? moduleSelected['value'] : ''
    };
    core
      .post({
        data: request,
        url: 'superinitWeb',
        method: 'post'
      })
      .then(response => {
        this.loading = false;
        store.dispatch('updateIsLoginAc', true);
        store.dispatch('updateSuperInitDataAc', response);
        this.$router.push({ name: "dashboard" });
      })
      .catch(error => {
        this.loading = false;
      });
  }
  staticData() {

    let request = {
      token: this.sessionValidateResponse.sessionId,
      requestModule: store.getters.sessLoginDataGet.requestModule,
      requestType: "WEB",
      merchantClientId: this.sessionValidateResponse.clientId
    };
    core
      .post({
        data: request,
        url: 'staticData',
        method: 'post'
      })
      .then(response => {
        this.loading = false;

        store.dispatch('updateStaticDataAc', response).then(() => {
          this.superInit();
        })

      })
      .catch(error => {
        this.loading = false;
      });
  }

  forgotPassword() {
    this.$router.push({ name: 'fgPass' });
  }

  createMasterHash() {
    let masterHashPwd = this.getHashedString(this.loginCredentials.password);
    for (let i = parseInt(this.initLoginResponse.hashCount); i > 0; i--) {
      masterHashPwd = this.getHashedString(masterHashPwd.substring(0, i) + this.initLoginResponse.randomSeed + masterHashPwd.substring(i));
    }
    return masterHashPwd;
  }

  getHashedString(string) {
    return shajs("sha256").update(string).digest("hex");
  }
  mounted() {
    store.dispatch('updateIsLoginAc', false);
    store.dispatch('updateTransInfoAc', null);
    store.dispatch('updateSuperInitDataAc', null);
    store.dispatch('updateSessLoginDataAc', null);
    store.dispatch('updateManageUserAc', null);
    store.dispatch('updateUserNavDataAc', true);
  }

  changeUser(user) {
    if (user == 'ADMIN') {
      this.isAdmin = true
    } else {
      this.isAdmin = false;
    }
  }
}
